import { ICategoryNameLocale } from '@/models/categories.model';
import { FilterType, IFilterValueLocale } from '@/models/filters.model';
import { UploadFile } from 'antd';

export enum EditCategoryFieldNames {
  LOCALE = 'locale',
  SLUG = 'slug',
  PHOTO = 'photo',
  PARENT_ID = 'parent_id',
  GOOGLE_FEED_ID = 'google_feed_id',
  IS_RESTORATION = 'is_restoration',
  IS_HEAVY = 'is_heavy',
}

export enum FiltersTableFiltersFieldNames {
  TYPE = 'type',
  TITLE = 'title',
  IS_ACTIVE = 'is_active',
  CATEGORIES = 'categories',
  PAGE = 'page',
  SLUG = 'slug',
}

export enum FiltersValuesFieldNames {
  TITLE_UK = 'title_UK',
  TITLE_RU = 'title_RU',
  SLUG = 'slug',
}

export type TEditCategoryFormValues = {
  [EditCategoryFieldNames.LOCALE]?: ICategoryNameLocale[];
  [EditCategoryFieldNames.SLUG]?: string;
  [EditCategoryFieldNames.PARENT_ID]?: string;
  [EditCategoryFieldNames.PHOTO]?: { file: UploadFile };
  [EditCategoryFieldNames.GOOGLE_FEED_ID]?: number;
  [EditCategoryFieldNames.IS_RESTORATION]?: boolean;
  [EditCategoryFieldNames.IS_HEAVY]?: boolean | null;
};

export enum CreateCategoryFieldNames {
  LOCALE = 'locale',
  PHOTO = 'photo',
  PARENT_ID = 'parent_id',
  GOOGLE_FEED_ID = 'google_feed_id',
  IS_HEAVY = 'is_heavy',
}

export enum FilterFormFieldNames {
  LOCALE = 'locale',
  POSITION = 'position',
  TYPE = 'type',
  STATUS = 'is_active',
  IS_SHOWN = 'filterable',
  IS_REQUIRED = 'required',
  SLUG = 'slug',
  CATEGORIES = 'categories',
  MIN = 'min',
  MAX = 'max',
}

export type TCreateCategoryFormValues = {
  [EditCategoryFieldNames.LOCALE]: ICategoryNameLocale[];
  [EditCategoryFieldNames.PARENT_ID]: string;
  [EditCategoryFieldNames.PHOTO]: { file: UploadFile };
};

export type TGetFiltersQuery = {
  [FiltersTableFiltersFieldNames.TYPE]?: FilterType;
  [FiltersTableFiltersFieldNames.TITLE]?: string;
  [FiltersTableFiltersFieldNames.IS_ACTIVE]?: boolean;
  [FiltersTableFiltersFieldNames.PAGE]?: number;
  [FiltersTableFiltersFieldNames.CATEGORIES]?: string[];
  [FiltersTableFiltersFieldNames.SLUG]?: string;
};

export type TGetFiltersValuesQuery = {
  [FiltersValuesFieldNames.TITLE_UK]?: string;
  [FiltersValuesFieldNames.TITLE_RU]?: string;
  [FiltersValuesFieldNames.SLUG]?: string;
};

export type TCreateFilterValue = {
  [FiltersValuesFieldNames.SLUG]: string;
  locale: IFilterValueLocale;
};
